// extracted by mini-css-extract-plugin
export default {"button":"BtnAdd_button__rwONv","large":"BtnAdd_large__IcwNo","add":"BtnAdd_add__v-Zfp"};